import voucherOrderTransformer from '../../transformers/voucherOrder';
import tableUtil from '../../utils/table';
import axios from 'axios';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'voucher-orders', {
        params,
      })
      .then(
        ({ data }) => {
          let dataRes = {};
          dataRes.data = data.data;
          if (data.data) {
            dataRes.data = voucherOrderTransformer.fetchCollection(data.data);
          }
          dataRes.meta = data.pagination ? { pagination: data.pagination } : tableUtil.mockupMeta(dataRes.data.length);
          resolve(dataRes);
        },
        (error) => {
          reject(error);
        }
      );
  });

  return promise;
};
